// AffiliateDisclaimerContent.js
const disclaimerData = {
    title: "Affiliate Disclaimer",
    paragraphs: [
        "MoneyRateFinder is a free comparison platform created to help users make informed decisions when sending money internationally. We analyze and display remittance service providers based on publicly available data, with the goal of offering accurate and unbiased information.",
        "At this time, we do not earn any commissions, referral fees, or financial compensation from the services or providers listed on our platform.",
        "However, to help us improve the user experience and performance of our site, we may use tools like Google Tag Manager for analytics and optimization purposes. These tools do not affect the objectivity of our content or rankings.",
        "In the future, if we partner with service providers through affiliate links or sponsored placements, we will clearly disclose such relationships to maintain transparency and trust with our users.",
        "Your trust is important to us, and we are committed to keeping our recommendations impartial and helpful.",
    ],
};

export default disclaimerData;
